import { webEnvironment } from '@/shared/config';
import SentryService from '../sentry/Sentry.service';

export interface EventAttendeeStylist {
  id: number;
  bio: string;
  user: {
    firstName: string;
    lastName: string;
    profilePicUrl: string;
  };
}

export class EventService {
  private static baseUrl = webEnvironment.server.baseUrl;

  /**
   * Fetches all stylists who are marked as event attendees
   * @returns Promise<EventAttendeeStylist[]> Array of event attendee stylists
   */
  static async getEventAttendeeStylists(): Promise<EventAttendeeStylist[]> {
    try {
      const response = await fetch(
        `${this.baseUrl}/api/event/attendee-stylists`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      SentryService.captureError(
        'Error fetching event attendee stylists:',
        error,
      );
      throw error;
    }
  }
}
